import { Linkedin, Mail, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-primary text-white py-20 border-t border-border/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-12">
            <div className="text-center md:text-left space-y-2">
              <p className="text-2xl font-bold tracking-tight font-sans mb-4">
                Peter Dingle
              </p>
              <p className="text-sm text-white/70 font-serif">
                {t("footer.tagline")}
              </p>
              <p className="text-xs text-white/50 font-sans tracking-wide mt-4">
                {t("footer.registered")}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4">
              <Button
                variant="ghost"
                size="lg"
                className="text-white hover:text-accent-mint hover:bg-white/5 transition-all rounded-sm flex items-center gap-2"
                onClick={() =>
                  window.open("https://www.linkedin.com/in/petermdingle/", "_blank")
                }
                aria-label="Connect on LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
                <span className="text-sm font-medium">{t("footer.linkedin")}</span>
              </Button>
              <Button
                asChild
                variant="ghost"
                size="lg"
                className="text-white hover:text-accent-mint hover:bg-white/5 transition-all rounded-sm flex items-center gap-2"
                aria-label="Email Peter"
              >
                <a href="mailto:peter@petermdingle.com?subject=Hello%20Peter">
                  <Mail className="h-5 w-5" />
                  <span className="text-sm font-medium">{t("footer.email")}</span>
                </a>
              </Button>
              <Button
                variant="ghost"
                size="lg"
                className="text-white hover:text-accent-mint hover:bg-white/5 transition-all rounded-sm flex items-center gap-2"
                onClick={() =>
                  window.open("https://calendar.app.google/smFTnDe7izrtAPVg6", "_blank")
                }
                aria-label="Book a Call"
              >
                <Calendar className="h-5 w-5" />
                <span className="text-sm font-medium">{t("footer.bookCall")}</span>
              </Button>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 text-center">
            <p className="text-xs text-white/50 font-sans tracking-wider">
              {t("footer.rights")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
